export const AUTH_LAYOUT = 'AUTH_LAYOUT'
export const ADMIN_LAYOUT = 'ADMIN_LAYOUT'